import { EditProduct as CatalogEditProduct } from './EditProduct';

export default CatalogEditProduct;
